import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '艾爾興紅光',
    component: () => import(/* webpackChunkName: "wx_index" */ '../views/Home.vue')
  },
  {
    path: '/phone',
    name: '艾爾興紅光',
    component: () => import(/* webpackChunkName: "wx_index" */ '../views/BindPhone.vue')
  },
  {
    path: '/userinfo',
    name: '資料修改',
    component: () => import(/* webpackChunkName: "wx_index" */ '../views/UserInfo.vue')
  },
  {
    path: '/resetpassword',
    name: '修改密碼',
    component: () => import(/* webpackChunkName: "wx_index" */ '../views/UpdatePassword.vue')
  },
  {
    path: '/charge',
    name: '套餐充值',
    component: () => import(/* webpackChunkName: "wx_index" */ '../views/ChargePackage.vue')
  },
  {
    path: '/chat',
    name: '在線咨詢',
    component: () => import(/* webpackChunkName: "wx_index" */ '../views/Chat.vue')
  },
  {
    path: '/revisit',
    name: '復診問卷',
    component: () => import(/* webpackChunkName: "wx_index" */ '../views/RevisitPage.vue')
  },
  {
    path: '/consent',
    name: '知情同意',
    component: () => import(/* webpackChunkName: "wx_index" */ '../views/ConsentPage.vue')
  },
  {
    path: '/agreement',
    name: '艾爾興服務協議',
    component: () => import(/* webpackChunkName: "wx_index" */ '../views/AgreementPage.vue')
  },
  {
    path: '/record',
    name: '使用情況',
    component: () => import(/* webpackChunkName: "wx_index" */ '../views/UserRecords.vue')
  },
  {
    path: '/session',
    name: '在線咨詢',
    component: () => import(/* webpackChunkName: "wx_index" */ '../views/SessionList.vue')
  },
  {
    path: '/visits',
    name: '健康檔案',
    component: () => import(/* webpackChunkName: "wx_index" */ '../views/VisitsList.vue')
  },
  {
    path: '/return',
    name: '滿意度調查問卷',
    component: () => import(/* webpackChunkName: "wx_index" */ '../views/UserReturnInfo.vue')
  },
  {
    path: '/chart',
    name: '視力曲線',
    component: () => import(/* webpackChunkName: "wx_chart" */ '../views/VisitChart.vue')
  },
  {
    path: '/points',
    name: '我的積分',
    component: () => import(/* webpackChunkName: "wx_chart" */ '../views/PointsRecord.vue')
  },
  {
    path: '/uploadData',
    name: '數據上傳',
    component: () => import(/* webpackChunkName: "wx_index" */'../views/UploadData.vue')
  },
  {
    path: '/qrcode',
    name: '售後服務',
    component: () => import(/* webpackChunkName: "wx_index" */'../views/QRCodePage.vue')
  },
  {
    path: '/unsubscribe',
    name: '請先關註',
    component: () => import(/* webpackChunkName: "wx_index" */'../views/Unsubscribe.vue')
  },
  {
    path: '/gift',
    name: '積分兌換',
    component: () => import(/* webpackChunkName: "wx_index" */'../views/PointsPage.vue')
  },
  {
    path: '/doctorlist',
    name: '醫生列表',
    component: () => import(/* webpackChunkName: "wx_index" */'../views/DoctorList.vue')
  },
  //  銷售醫生
  {
    path: '/doctor',
    component: () => import(/* webpackChunkName: "doctor" */ '../views/DoctorApp.vue'),
    children: [
      {
        // 當 /user/:id/profile 匹配成功，
        // UserProfile 會被渲染在 User 的 <router-view> 中
        name: '個人中心',
        path: '/doctor',
        component: () => import(/* webpackChunkName: "doctor" */ '../views/DoctorHome.vue')
      },
      {
        path: '/doctor/info',
        name: '資料修改',
        component: () => import(/* webpackChunkName: "doctor" */ '../views/DoctorInfo.vue')
      },
      {
        path: '/doctor/user',
        name: '相關患者',
        component: () => import(/* webpackChunkName: "doctor" */ '../views/UserList.vue')
      },
      {
        path: '/doctor/order',
        name: '患者訂單',
        component: () => import(/* webpackChunkName: "doctor" */ '../views/OrderList.vue')
      },
      {
        path: '/doctor/visit',
        name: '完善報告',
        component: () => import(/* webpackChunkName: "doctor" */ '../views/EdivUserVisit.vue')
      }
    ],
    // beforeEnter: (to, from, next) => {
    //   var user = global.defaultStore.state.user
    //   console.log(user)
    //   if (user && user.user && user.user.openid) {
    //     if (user.user.type === "saleman") {
    //       next()
    //     } else {
    //       next('/')
    //     }
    //   } else {
    //     next('/phone')
    //   }
    // }
  },
  //  渠道後臺醫生
  {
    path: '/hospital_doctor',
    component: () => import(/* webpackChunkName: "doctor" */ '../views/HospitalDoctor/HospitalDoctorApp.vue'),
    children: [
      {
        name: '個人中心',
        path: '/hospital_doctor',
        component: () => import(/* webpackChunkName: "doctor" */ '../views/HospitalDoctor/HospitalDoctorList.vue')
      },
      {
        name: '問題列表',
        path: '/hospital_doctor/questions',
        component: () => import(/* webpackChunkName: "doctor" */ '../views/HospitalDoctor/HospitalQuestionList.vue')
      },
      {
        name: '用戶資料',
        path: '/hospital_doctor/user/:id',
        component: () => import(/* webpackChunkName: "doctor" */ '../views/HospitalDoctor/VisitsList.vue')
      },
      {
        name: '用戶資料',
        path: '/hospital_doctor/user/record/:id',
        component: () => import(/* webpackChunkName: "doctor" */ '../views/HospitalDoctor/UserRecords.vue')
      },
      {
        name: '用戶資料',
        path: '/hospital_doctor/user/chart/:id',
        component: () => import(/* webpackChunkName: "doctor" */ '../views/HospitalDoctor/VisitChart.vue')
      },
    ],
  }
]
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  if (to.name) {
    document.title = to.name
  }
  next()
})
export default router
